import type { PlanCode } from './prototypeTypes';

export type GuardIntent = 'favorite' | 'progress' | 'vote' | 'comment' | 'ai' | 'idea' | 'feedback' | 'generic';
export type ClientIntent = 'submitIdea' | 'voteIdea' | 'commentIdea' | 'aiCreate';
export type IntentDecision =
	| { allowed: true }
	| { allowed: false; reason: 'login'; intent: GuardIntent }
	| { allowed: false; reason: 'upgrade'; intent: GuardIntent; requiredPlan: PlanCode };

const intentToRequiredPlan: Record<ClientIntent, PlanCode> = {
	submitIdea: 'free',
	voteIdea: 'free',
	commentIdea: 'free',
	aiCreate: 'free',
};

/** Mirrors the server policy for click-time login and plan pre-checks. */
export function checkClientIntent(
	state: { isLoggedIn: boolean; currentPlan: PlanCode; effectiveAccessPlan?: PlanCode },
	intent: ClientIntent,
): IntentDecision {
	const accessPlan = state.effectiveAccessPlan ?? state.currentPlan;
	if (!state.isLoggedIn || accessPlan === 'visitor') {
		return { allowed: false, reason: 'login', intent: intentToGuardIntent(intent) };
	}
	if (intent === 'submitIdea' || intent === 'voteIdea' || intent === 'commentIdea') {
		return { allowed: true };
	}
	const requiredPlan = intentToRequiredPlan[intent];
	const rank: Record<PlanCode, number> = { visitor: 0, free: 0, lite: 1, pro: 2, max: 3 };
	if (rank[accessPlan] >= rank[requiredPlan]) return { allowed: true };
	return { allowed: false, reason: 'upgrade', intent: intentToGuardIntent(intent), requiredPlan };
}

function intentToGuardIntent(intent: ClientIntent): GuardIntent {
	if (intent === 'aiCreate') return 'ai';
	if (intent === 'submitIdea') return 'idea';
	return 'generic';
}
